// extracted by mini-css-extract-plugin
export var fullGrid = "_2i-3";
export var pdpPreviewContainer = "_2i-1";
export var previewContainer = "_2i-0";
export var togglePreviewContainer = "_2i-2";